import { render } from "./InvitePhoneField.vue?vue&type=template&id=2c833dca"
import script from "./InvitePhoneField.vue?vue&type=script&lang=js"
export * from "./InvitePhoneField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__